export const PRODUCTION_SIDEKICK_APP_URL = "https://app.sidekickgpt.io";

export const TERMS_OF_SERVICE_AND_PRIVACY_POLICY_URL =
  "https://www.sidekickdata.io/legal";

export const SIDEKICK_WEBSITE_URL = "https://sidekickdata.io";

export const RADAR_WEBSITE_URL = "https://www.joinradar.ai";

export const JOIN_SIDEKICK_INTEREST_LIST_URL =
  "https://www.sidekickdata.io/request-a-demo";

export const SIDEKICK_SUPPORT_EMAIL = "support@sidekickdata.io";

export const INDIVIDUAL_PLAN_ID = "individual";
